function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Heading from '../Heading';
import DashboardLayout from '../layouts/DashboardLayout';
import Panel from '../Panel';
import { SimpleGrid, Text, Heading as ChakraHeading, Icon, Stack, Button, ButtonGroup, HStack, Tag, Divider, useDisclosure } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router';
import { WebRoutes } from '@/utils/constants';
import { connectDiscordIntegration, disconnectDiscordIntegration, getDiscordIntegration } from '@/actions/IntegrationActions';
import useChannelStore from '@/stores/ChannelStore';
import InputModal from '../InputModal';
import { HTTPError } from '@/utils/api';
import { Helmet } from 'react-helmet';
function IntegrationPanel(param) {
    var title = param.title, description = param.description, icon = param.icon, isConnected = param.isConnected, isLoading = param.isLoading, onConnect = param.onConnect, onDisconnect = param.onDisconnect, onEdit = param.onEdit;
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(false), 2), connecting = _React_useState[0], setConnecting = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), disconnecting = _React_useState1[0], setDisconnecting = _React_useState1[1];
    var disconnectModal = useDisclosure();
    var handleDisconnect = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            setDisconnecting(true);
            onDisconnect().finally(function() {
                return setDisconnecting(false);
            });
            return [
                2
            ];
        });
    }), [
        onDisconnect
    ]);
    var handleConnect = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            setConnecting(true);
            onConnect().finally(function() {
                return setConnecting(false);
            });
            return [
                2
            ];
        });
    }), [
        onConnect
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Panel, {
                padding: 0,
                maxWidth: "360px",
                gap: 4,
                children: [
                    /*#__PURE__*/ _jsxs(Stack, {
                        padding: 6,
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ _jsxs(HStack, {
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                children: [
                                    icon,
                                    isConnected ? /*#__PURE__*/ _jsx(Tag, {
                                        size: "sm",
                                        colorScheme: "green",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: "IvjoDS",
                                            defaultMessage: "Connected"
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ _jsx(ChakraHeading, {
                                size: "sm",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                color: "textSecondary",
                                fontSize: "sm",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    /*#__PURE__*/ _jsx(ButtonGroup, {
                        display: "flex",
                        size: "sm",
                        justifyContent: "space-between",
                        padding: 6,
                        gap: 4,
                        children: isConnected ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    colorScheme: "red",
                                    flex: 1,
                                    onClick: disconnectModal.onOpen,
                                    isLoading: disconnecting,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "qj1uhz",
                                        defaultMessage: "Disconnect"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    flex: 1,
                                    onClick: onEdit,
                                    isDisabled: disconnecting,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "wEQDC6",
                                        defaultMessage: "Edit"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(Button, {
                            flex: 1,
                            isLoading: connecting || isLoading,
                            onClick: handleConnect,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "+vVZ/G",
                                defaultMessage: "Connect"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                title: intl.formatMessage({
                    id: "eR7yNV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disconnect Integration"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "H1Szmh",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to disconnect this integration?"
                        }
                    ]
                }),
                isOpen: disconnectModal.isOpen,
                onClose: disconnectModal.onClose,
                onSubmit: handleDisconnect,
                submitText: intl.formatMessage({
                    id: "qj1uhz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disconnect"
                        }
                    ]
                })
            })
        ]
    });
}
function DiscordIntegrationPanel() {
    var intl = useIntl();
    var navigate = useNavigate();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useState = _sliced_to_array(React.useState(false), 2), isloading = _React_useState[0], setIsLoading = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), isConnected = _React_useState1[0], setIsConnected = _React_useState1[1];
    React.useEffect(function() {
        if (channel == null) {
            return;
        }
        setIsLoading(true);
        getDiscordIntegration(channel._id).then(function() {
            setIsConnected(true);
            setIsLoading(false);
        }).catch(function(error) {
            if (!_instanceof(error, HTTPError)) {
                throw error;
            }
            if ((error === null || error === void 0 ? void 0 : error.statusCode) !== 404) {
                throw error;
            }
            setIsLoading(false);
        });
    }, [
        channel
    ]);
    var handleDisconnect = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (channel == null) {
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        disconnectDiscordIntegration(channel._id)
                    ];
                case 2:
                    _state.sent();
                    setIsConnected(false);
                    return [
                        3,
                        4
                    ];
                case 3:
                    _ = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        channel
    ]);
    var handleConnect = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (channel == null) {
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        connectDiscordIntegration(channel._id)
                    ];
                case 2:
                    _state.sent();
                    setIsConnected(true);
                    return [
                        3,
                        4
                    ];
                case 3:
                    _ = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        channel
    ]);
    if (channel == null) {
        return null;
    }
    return /*#__PURE__*/ _jsx(IntegrationPanel, {
        isLoading: isloading,
        isConnected: isConnected,
        icon: /*#__PURE__*/ _jsx(Icon, {
            padding: 2,
            size: "xl",
            color: "white",
            backgroundColor: "brandDiscordBlurple",
            borderRadius: "lg",
            as: FontAwesomeIcon,
            icon: faDiscord
        }),
        title: intl.formatMessage({
            id: "FvmV6q",
            defaultMessage: [
                {
                    type: 0,
                    value: "Discord"
                }
            ]
        }),
        description: intl.formatMessage({
            id: "+ZPmis",
            defaultMessage: [
                {
                    type: 0,
                    value: "Integrate with Discord for commands, synced roles, and chat moderation."
                }
            ]
        }),
        onDisconnect: handleDisconnect,
        onConnect: handleConnect,
        onEdit: function() {
            return navigate(WebRoutes.INTEGRATIONS_DISCORD);
        }
    });
}
export default function Integrations() {
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var intl = useIntl();
    if (channel == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "6cBDhe",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Integrations"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: "Connect Nightbot to other services",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "6cBDhe",
                    defaultMessage: "Integrations"
                })
            }),
            /*#__PURE__*/ _jsx(SimpleGrid, {
                columns: 1,
                spacing: 6,
                minChildWidth: "300px",
                children: /*#__PURE__*/ _jsx(DiscordIntegrationPanel, {})
            })
        ]
    });
}
